import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { CLINIC } from "../data/catalog";
import { WhatsAppGlyph } from "./WhatsAppFloat";

const ClosingBlock = () => (
  <section className="bg-ink text-cream" data-testid="closing-block">
    <div className="mx-auto flex max-w-7xl flex-col items-start gap-8 px-4 py-16 md:flex-row md:items-center md:justify-between md:px-8 md:py-20">
      <Reveal>
        <h2 className="max-w-lg font-serif text-3xl font-light leading-snug md:text-4xl">
          Made by a doctor. <span className="italic text-sage">Made in small batches.</span>
        </h2>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-cream/60">
          Ten products. Made in our own licensed facility in Thiruvananthapuram.
        </p>
      </Reveal>
      <Reveal delay={0.12} className="flex flex-wrap gap-4">
        <Link
          to="/shop"
          data-testid="closing-shop-cta"
          className="group inline-flex items-center gap-3 rounded-full bg-cream px-7 py-3.5 text-[12px] uppercase tracking-[0.18em] text-ink transition-colors duration-300 hover:bg-sage hover:text-ink-deep"
        >
          Shop the Range
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
        <a
          href={CLINIC.whatsapp}
          target="_blank"
          rel="noreferrer"
          data-testid="closing-whatsapp-cta"
          className="inline-flex items-center gap-3 rounded-full border border-cream/30 px-7 py-3.5 text-[12px] uppercase tracking-[0.18em] text-cream transition-colors duration-300 hover:border-cream"
        >
          <WhatsAppGlyph className="h-4 w-4" />
          Ask Us on WhatsApp
        </a>
      </Reveal>
    </div>
  </section>
);

export default ClosingBlock;
